module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/shared-ownership-926a1c86cb1c0ff46cae46a99e6ccbc6.png";